var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeDotActionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 17,
    viewBox: "0 0 5 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.56797 15.75C2.09853 15.75 1.71797 15.3694 1.71797 14.9C1.71797 14.4306 2.09853 14.05 2.56797 14.05C3.03741 14.05 3.41797 14.4306 3.41797 14.9C3.41797 15.3694 3.03741 15.75 2.56797 15.75ZM2.56797 9.35C2.09853 9.35 1.71797 8.96944 1.71797 8.5C1.71797 8.03056 2.09853 7.65 2.56797 7.65C3.03741 7.65 3.41797 8.03056 3.41797 8.5C3.41797 8.96944 3.03741 9.35 2.56797 9.35ZM2.56797 2.95C2.09853 2.95 1.71797 2.56944 1.71797 2.1C1.71797 1.63056 2.09853 1.25 2.56797 1.25C3.03741 1.25 3.41797 1.63056 3.41797 2.1C3.41797 2.56944 3.03741 2.95 2.56797 2.95Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotActionIcon);
export default __webpack_public_path__ + "static/media/three-dot-action-icon.051d5259b0498e90c624ca93f42d3425.svg";
export { ForwardRef as ReactComponent };